import React, { useEffect, useRef } from 'react';
import './Integrity.css';
import aiIcon from '../../assets/icons/AI.svg';
import codeIcon from '../../assets/icons/code.svg'
import syncIcon from '../../assets/icons/sync.svg'
import trophyIcon from '../../assets/icons/trophy.svg'


const Integrity = () => {
  const containerRef = useRef();
  const pillarRefs = useRef([]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('animate');
            
            // Animate pillars
            pillarRefs.current.forEach((ref, index) => {
              if (ref) {
                setTimeout(() => {
                  ref.style.height = ref.getAttribute('data-value');
                }, 200 * index);
              }
            });
          }
        });
      },
      { threshold: 0.1 }
    );

    if (containerRef.current) {
      observer.observe(containerRef.current);
    }

    return () => {
      if (containerRef.current) {
        observer.unobserve(containerRef.current);
      }
    };
  }, []);

  const pillars = [
    {
      title: "AI-Powered Precision",
      description: "Automated project scoping with intelligent quotation generation",
      value: "100%",
      icon: <img src={aiIcon} alt="AI Icon" className="pillar-svg-icon" />
    },
    {
      title: "Full Development Cycle",
      description: "End-to-end solutions from concept to deployment",
      value: "100%",
      icon: <img src={codeIcon} alt="Development Icon" className="pillar-svg-icon" />
    },
    {
      title: "Client Collaboration",
      description: "Interactive quotation editing and real time revisions",
      value: "100%",
      icon: <img src={syncIcon} alt="sync Icon" className="pillar-svg-icon" />
    },
    {
      title: "Proven Track Record",
      description: "Dozens of successful projects across multiple industries",
      value: "100%",
      icon: <img src={trophyIcon} alt="trophy Icon" className="pillar-svg-icon" />
    }
  ];

  return (
    <div className="integrity-container" ref={containerRef} id="integrity">
      <div className="integrity-header">
        <div className="integrity-badge">Skript PILLARS</div>
        <h2 className="integrity-title">Engineering <span className='title-highlight'>Trust</span> Through Technology</h2>
        <p className="integrity-subtitle">
          Our methodology combines cutting-edge technology with proven processes
        </p>
      </div>

      <div className="pillars-container">
        {pillars.map((pillar, index) => (
          <div key={index} className="pillar">
            <div className="pillar-visual">
              <div className="pillar-icon">{pillar.icon}</div>
              <div className="pillar-track">
                <div 
                  className="pillar-progress" 
                  ref={el => pillarRefs.current[index] = el}
                  data-value={pillar.value}
                ></div>
              </div>
            </div>
            <div className="pillar-content">
              <h3>{pillar.title}</h3>
              <p>{pillar.description}</p>
            </div>
          </div>
        ))}
      </div>

      <div className="circuit-overlay"></div>
    </div>
  );
};

export default Integrity;